<template>
  <div class="shaoxingHome">
    <Header
      :tabList="tabList"
      :value="selectValue"
      @change="onTabChange"
    />
    <router-view></router-view>
    <Footer
      :info="info"
    />
  </div>
</template>
<script>
import Header from "../shaoxing/components/header";
import Footer from "../shaoxing/components/footer";

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      tabList: [
        {
          label: '首页',
          value: 'home',
          routeName: 'shaoxingHomePage',
          path: '/index',
        },
        {
          label: '景区门票',
          value: 'ScenicTicket',
          routeName: 'shaoxingScenicTicket',
          path: '/scenicTicket',
        },
        {
          label: '餐饮美食',
          value: 'hotel',
          routeName: 'shaoxingHotel',
          path: '/hotel',
          pid: 902,
        },
        // {
        //   label: '自由行',
        //   value: 'freeWalker',
        //   routeName: 'shaoxingFreeWalker',
        //   path: '/freeWalker',
        //   pid: 903,
        // },
        {
          label: '',
        },
        {
          label: '跟团游',
          value: 'packageTour',
          routeName: 'shaoxingPackageTour',
          path: '/packageTour',
          pid: 904,
        },
        {
          label: '特色纪念品',
          value: 'souvenir',
          routeName: 'shaoxingSouvenir',
          path: '/souvenir',
        },
        {
          label: '游记攻略',
          value: 'strage',
          routeName: 'shaoxingStrage',
          path: '/strage',
          pid: 902,
        },
        // {
        //   label: '亲子游',
        //   value: 'familyTrip',
        //   routeName: 'shaoxingFamilyTrip',
        //   path: '/familyTrip',
        //   pid: 904,
        // },
      ],
      selectValue: 'shaoxingHomePage',
      info: {},
    };
  },
  methods: {
    // 菜单切换(更换 前端菜单写死)
    onTabChange(data) {
      this.selectValue = data.routeName;
      console.log({ data })
      localStorage.setItem('selectValue', data.routeName);
      if (data.linkUrl === 'customlink') { // 自定义链接跳转
        window.location.href = data.customLinkurl;
      } else if(data.routeName === 'shaoxingHomePage') { // 首页
        this.$router.push({
          path: '/',
        });
      } else if (data.value === 'ScenicTicket') { // 景区门票
        this.$router.push({
          path: '/list/ticket',
          query: {
            page: 1,
            m_id: this.$route.query.m_id
          }
        });
      } else if (data.value === 'hotel') { // 餐饮美食
        this.$router.push({
          path: '/list/eatery',
          query: {
            page: 1,
            m_id: this.$route.query.m_id
          }
        });
      } else if (data.value === 'packageTour') { // 跟团游
        this.$router.push({
          path: '/list/route',
          query: {
            page: 1,
            m_id: this.$route.query.m_id
          }
        });
      } else if (data.value === 'souvenir') { // 特色纪念品
        this.$router.push({
          path: '/list/shop',
          query: {
            page: 1,
            m_id: this.$route.query.m_id
          }
        });
      } else if (data.value === 'strage') { // 游记攻略
        this.$router.push({
          path: '/newslist',
          query: {
            pid: 957,
            m_id: this.$route.query.m_id
          }
        });
      }
    },
  }
}
</script>
<style scoped>
.shaoxingHome {
  width: 100%;
  overflow: hidden;
  background: #FFF;
}
</style>


// WEBPACK FOOTER //
// src/pages/shaoxing/index.vue